import { PulseContentItem } from "plos/src/utils/pulse";
import { TeamNewsItem } from "../TeamNewsItem";
import { fixtureNewsStyles } from "./fixtureNews.css";
import { FixtureNewsHeader } from "./FixtureNewsHeader";
import { FixtureNewsProps } from "./types";
import HorizontalDivider from "plos/src/components/HorizontalDivider";

const FixtureNews = ({
  homeTeam,
  awayTeam,
  fixtureNewsArticles,
}: FixtureNewsProps) => {
  const getTeamFromArticle = (article: PulseContentItem) => {
    const teamCode = article.references.find(
      (r) => r.type === "SDP_FOOTBALL_TEAM",
    )?.id;
    if (!teamCode) return null;

    // Match article team code with home or away team opta code
    if (homeTeam.code === teamCode) return homeTeam;
    if (awayTeam.code === teamCode) return awayTeam;
    return null;
  };

  return (
    <div className={fixtureNewsStyles}>
      <FixtureNewsHeader homeTeam={homeTeam} awayTeam={awayTeam} />
      <HorizontalDivider />
      {fixtureNewsArticles.map((article) => (
        <TeamNewsItem
          key={article.id}
          article={article}
          team={getTeamFromArticle(article)}
        />
      ))}
    </div>
  );
};
export default FixtureNews;
